import * as Sentry from "@sentry/react";

const trackErrors = () => {
  const isProduction = import.meta.env.VITE_CUSTOM_NODE_ENV === "production";
  const currentUrl = window.location.href;

  // Regex to match excluded URLs
  const excludedUrlsRegex =
    /^(https:\/\/(app|dev)\.reelo\.io\/l(\/(referral\/[^/]+|approval\/[^/]+|[^/]+))?|http:\/\/localhost:\d+\/l(\/(referral\/[^/]+|approval\/[^/]+|[^/]+))?)$/;

  // Test if the current URL matches the excluded URLs
  const isExcluded = excludedUrlsRegex.test(currentUrl);

  // Skip further execution if not production or the URL is excluded
  if (!isProduction || isExcluded) return;

  Sentry.init({
    autoSessionTracking: true,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_CUSTOM_NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Tracing
    tracesSampleRate: 0,
    tracePropagationTargets: [],
    enableAutoPerformanceTracing: false,

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    beforeSend(event) {
      const url = event.request?.url || "";
      if (excludedUrlsRegex.test(url)) {
        return null; // Drop the event
      }
      return event; // Otherwise, keep it
    },

    beforeSendTransaction(event) {
      if (excludedUrlsRegex.test(event.transaction || "")) {
        return null; // Drop the transaction
      }
      return event; // Otherwise, keep it
    },
  });
};

export default trackErrors;
